var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-chart',{attrs:{"data":_vm.data,"type":"line","title":"linechart","config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }